<template>

	<form :method="method" action="#" @submit.prevent="submit">
		<slot></slot>
	</form>

</template>
<script>
// import useVuelidate from '@vuelidate/core'
// import { required, email, sameAs, minLength } from '@vuelidate/validators'
// import ValidateErrors from '@/components/validate-errors'

export default {
	props: {
		method: {
			type: String,
			default: 'post'
		},
		api: {
			type: String,
		},
		validate: {
			type: Boolean,
			default: true
		}
	},
	emits: {
		'submit': null,
		'submit-fail': null,
		'submit-done': null,
	},
	// setup(props) {
	setup() {
		// console.log('SETUP', props.validate)
	},
	components: {
		// ValidateErrors,
	},
	methods: {
		submit() {
			this.$emit('submit');
		}
	}
};
</script>